import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const CartDrawer = ({ isOpen, onClose, cartItems, updateQuantity, removeItem }) => {
  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  // Inject responsive styles
  useEffect(() => {
    const styleId = 'cart-drawer-styles';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .cart-drawer {
          position: fixed;
          top: 0;
          right: 0;
          width: 33.33%;
          max-width: 100%;
          height: 100vh;
          background-color: #0D0D0D;
          z-index: 999;
          display: flex;
          flex-direction: column;
          font-family: 'TASA Orbiter Display', sans-serif;
          transition: transform 0.3s ease;
        }
        
        @media (max-width: 768px) {
          .cart-drawer {
            width: 100vw;
          }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <>
      {/* Backdrop with blur */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          zIndex: 998,
          opacity: isOpen ? 1 : 0,
          visibility: isOpen ? 'visible' : 'hidden',
          transition: 'opacity 0.3s ease, visibility 0.3s ease',
        }}
      />

      {/* Cart Drawer */}
      <div
        className="cart-drawer"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
        }}
      >
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 10px',
        }}>
          <h2 style={{
            fontSize: '16px',
            fontWeight: '400',
            color: '#F1F1F1',
            margin: 0,
          }}>
            Cart
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: '#6f6f6f',
              fontSize: '14px',
              cursor: 'pointer',
              padding: '4px',
              lineHeight: 1,
            }}
          >
            ✕
          </button>
        </div>

        {/* Cart Items */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: '20px 10px',
        }}>
          {cartItems.length === 0 ? (
            <p style={{
              color: '#6f6f6f',
              fontSize: '14px',
              textAlign: 'center',
            }}>
              Your cart is empty.
            </p>
          ) : (
            cartItems.map((item, index) => (
              <div
                key={`${item.id}-${item.size}-${index}`}
                style={{
                  display: 'flex',
                  gap: '16px',
                  marginBottom: '24px',
                  paddingBottom: '24px',
                  borderBottom: index < cartItems.length - 1 ? '1px solid #1C1C1C' : 'none',
                }}
              >
                {/* Product Image */}
                <div style={{
                  width: '100px',
                  height: '120px',
                  flexShrink: 0,
                  backgroundColor: '#1C1C1C',
                  overflow: 'hidden',
                }}>
                  <img
                    src={item.image}
                    alt={item.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </div>

                {/* Product Details */}
                <div style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                }}>
                  {/* Name and Price */}
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '4px',
                  }}>
                    <span style={{
                      fontSize: '14px',
                      color: '#F1F1F1',
                    }}>
                      {item.name}
                    </span>
                    <span style={{
                      fontSize: '14px',
                      color: '#F1F1F1',
                    }}>
                      € {(item.price * item.quantity).toFixed(2)}
                    </span>
                  </div>

                  {/* Size */}
                  {item.size && (
                    <span style={{
                      fontSize: '14px',
                      color: '#6f6f6f',
                      marginBottom: '16px',
                    }}>
                      Size: {item.size}
                    </span>
                  )}

                  {/* Quantity and Remove */}
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: 'auto',
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                    }}>
                      <span style={{
                        fontSize: '14px',
                        color: '#6f6f6f',
                      }}>
                        Quantity
                      </span>
                      <button
                        onClick={() => updateQuantity(item.id, item.size, item.quantity - 1)}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#F1F1F1',
                          fontSize: '14px',
                          cursor: 'pointer',
                          
                        }}
                      >
                        ‹
                      </button>
                      <span style={{
                        fontSize: '14px',
                        color: '#F1F1F1',
                        minWidth: '20px',
                        textAlign: 'center',
                      }}>
                        {item.quantity}
                      </span>
                      <button
                        onClick={() => updateQuantity(item.id, item.size, item.quantity + 1)}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#F1F1F1',
                          fontSize: '14px',
                          cursor: 'pointer',
                          
                        }}
                      >
                        ›
                      </button>
                    </div>

                    <button
                      onClick={() => removeItem(item.id, item.size)}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#6f6f6f',
                        fontSize: '16px',
                        cursor: 'pointer',
                        textUnderlineOffset: '2px',
                      }}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Footer - Subtotal and Checkout */}
        {cartItems.length > 0 && (
          <div style={{
            padding: '10px',
            
          }}>
            {/* Subtotal */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '20px',
            }}>
              <span style={{
                fontSize: '18px',
                color: '#F1F1F1',
              }}>
                Subtotal
              </span>
              <span style={{
                fontSize: '14px',
                color: '#F1F1F1',
              }}>
                € {subtotal.toFixed(2)}
              </span>
            </div>

            {/* Shipping Note */}
            <p style={{
              fontSize: '14px',
              color: '#6f6f6f',
              marginBottom: '20px',
            }}>
              Shipping calculated at checkout.
            </p>

            {/* Checkout Button */}
            <Link
              to="/checkout"
              onClick={onClose}
              style={{
                display: 'block',
                width: '100%',
                padding: '14px',
                backgroundColor: '#F1F1F1',
                color: '#0D0D0D',
                border: 'none',
                fontSize: '14px',
                fontWeight: '400',
                fontFamily: "'TASA Orbiter Display', sans-serif",
                textAlign: 'center',
                textDecoration: 'none',
                cursor: 'pointer',
                transition: 'opacity 0.2s ease',
              }}
            >
              Continue to Checkout
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default CartDrawer;